// extracted by mini-css-extract-plugin
module.exports = {"annotation":"_373a3719ba--annotation--nWzV9","title":"_373a3719ba--title--zYLeW","icon":"_373a3719ba--icon--CFEY3","text":"_373a3719ba--text--lDwQb"};